<template>
  <div>
    <v-subheader class="px-0 body-2 font-weight-medium" style="cursor: text;">Recientes</v-subheader>
    <v-skeleton-loader v-if="loading" transition="fade-transition" type="list-item-three-line" />

    <template v-else>
      <v-list-item class="py-0 pl-2" @click="goToDetails(agent.id)" v-for="agent in recentAgents" dense exact :key="agent.id" :ripple="false">
        <v-list-item-avatar class="ma-0" size="24">
          <img :alt="agent.name" :src="require(`@/assets/appAsset-agents-avatar-1.png`)" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="ml-2 subtitle-2 d-inline-block text-truncate" style="max-width: 140px;">{{ agent.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="!recentAgents.length" class="py-0" :ripple="false">
        <v-list-item-title class="caption text--disabled">Sin agentes recientes</v-list-item-title>
      </v-list-item>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import { agentAvatars } from '@/collections/agents'

export default {
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState({
      agentsList: state => state.agents.agentsList
    }),
    recentAgents () {
      return this.agentsList.slice(0, 3)
    }
  },
  created () {
    if (!this.agentsList.length) {
      this.loading = true
      this.$store.dispatch('agents/LIST', {
        resource: 'agents'
      })
      .finally(() => {
        this.loading = false
      })
    }
  },
  methods: {
    avatarConfig (avatar) {
      return agentAvatars.find(a => a.value === avatar) || agentAvatars[0]
    },
    createAgent () {
      this.$router.push({
        name: 'AgentCreate'
      })
      .catch(err => err)
    },
    goToDetails (id) {
      this.$router.push({
        name: 'AgentRetrieve',
        params: {
          id: id
        }
      })
      .catch(err => err)
    }
  }
}
</script>
<style scoped>
::v-deep .theme--light.v-skeleton-loader .v-skeleton-loader__list-item-three-line {
  background: transparent !important;
}
</style>
